import { Col, Row, Stack } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle,
  faPause,
  faSquare,
  faStar,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type StatType = {
  label: string;
  value: number;
  color: 'success' | 'danger' | 'warning';
  icon: IconProp;
};

interface EcomStatsProps {
  weekOrderData: number;
  totalOrders: number;
  products: number;
}

const EcomStats = ({
  weekOrderData,
  totalOrders,
  products
}: EcomStatsProps) => {
  const stats: StatType[] = [
    {
      label: 'New Orders',
      value: weekOrderData,
      color: 'success',
      icon: faStar
    },
    {
      label: 'Total Orders',
      value: totalOrders,
      color: 'danger',
      icon: faPause
    },
    {
      label: 'Total Products',
      value: products,
      color: 'warning',
      icon: faXmark
    }
  ];

  return (
    <Row className="g-4">
      {stats.map(({ label, value, color, icon }, idx) => (
        <Col xs={12} sm={6} md={4} key={idx}>
          <Stack direction="horizontal" className="align-items-center">
            <span
              className="fa-layers fa-fw d-inline-block"
              style={{ width: '48px', height: '48px' }}
            >
              <FontAwesomeIcon
                icon={faSquare}
                size="2x"
                className={`text-${color}-light opacity-25`}
              />
              <FontAwesomeIcon
                icon={faCircle}
                size="2x"
                className={`text-${color} opacity-50`}
                transform="shrink-6"
              />
              <FontAwesomeIcon
                icon={icon}
                className={`text-${color}`}
                transform="shrink-4"
              />
            </span>
            <div className="ms-3">
              <h5 className="mb-1 fw-semibold">{value}</h5>
              <div className="text-body-secondary small">{label}</div>
            </div>
          </Stack>
        </Col>
      ))}
    </Row>
  );
};

export default EcomStats;
